import { render, staticRenderFns } from "./BrandInfo.html?vue&type=template&id=f3c9bc46&scoped=true&"
import script from "./BrandInfo.vue?vue&type=script&lang=js&"
export * from "./BrandInfo.vue?vue&type=script&lang=js&"
import style0 from "./BrandInfo.vue?vue&type=style&index=0&id=f3c9bc46&scoped=true&lang=css&"
import style1 from "./BrandInfo.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3c9bc46",
  null
  
)

export default component.exports